function debounce(fn, delay) {
	let timer = null;
	return function (...args) {
		clearTimeout(timer);
		timer = setTimeout(() => fn.apply(this, args), delay);
	};
}

export default function initReadMore() {
	const mq = window.matchMedia('(min-width: 601px)');
	if (!mq.matches) return;

	const article = document.querySelector('article');
	const articleMain = document.querySelector('.article__main');
	const articleBody = document.querySelector('.article__body');
	const relatedWrapper = document.getElementById('related-wrapper');
	const readMoreWrapper = document.querySelector('.article__hide-buttons');
	const readMoreCheckbox = document.getElementById('article-switch');
	const allRelatedItems = relatedWrapper?.querySelectorAll('.cards__item');

	if (!article || !articleMain || !articleBody || !relatedWrapper || !readMoreWrapper || !readMoreCheckbox || !allRelatedItems) {
		console.warn('check readMore.js - missing elements');
		return;
	}

	const maxRelatedVisible = 3;
	const minRelatedVisible = 1;
	let visibleCount = maxRelatedVisible;

	const showCards = (count) => {
		allRelatedItems.forEach((item, i) => {
			item.style.display = i < count ? '' : 'none';
			item.style.visibility = i < count ? 'visible' : 'hidden';
		});
	};

	const adjustLayout = () => {
		const articleHeight = article.offsetHeight;
		const relatedHeight = relatedWrapper.offsetHeight;

		const BUFFER = 60;

		if ((relatedHeight - articleHeight) > BUFFER && visibleCount > minRelatedVisible) {
			visibleCount--;
			showCards(visibleCount);
			adjustLayout();
			return;
		}

		if (visibleCount === maxRelatedVisible && articleHeight > relatedHeight) {
			articleMain.classList.add('has-read-more');
			articleBody.style.maxHeight = `${relatedHeight}px`;
			readMoreWrapper.style.display = 'block';
		} else {
			articleMain.classList.remove('has-read-more');
			articleBody.style.maxHeight = 'none';
			readMoreWrapper.style.display = 'none';
			readMoreCheckbox.checked = false;
		}
	};

	const handleResize = debounce(() => {
		if (!mq.matches) return;
		const previous = visibleCount;
		visibleCount = maxRelatedVisible;
		if (previous !== maxRelatedVisible) {
			showCards(visibleCount);
		}
		adjustLayout();
	}, 200);

	// Initial layout
	showCards(visibleCount);
	adjustLayout();

	window.addEventListener('resize', handleResize);
	window.addEventListener('load', adjustLayout);

	readMoreCheckbox.addEventListener('change', () => {
		if (!readMoreCheckbox.checked) {
			articleBody.style.maxHeight = `${relatedWrapper.offsetHeight}px`;
		} else {
			articleBody.style.maxHeight = 'none';
		}
	});
}
